// extracted by mini-css-extract-plugin
module.exports = {"container":"ColumnBlock_container__jRjmV","headline":"ColumnBlock_headline__4_Xo8","threeColumns":"ColumnBlock_threeColumns__08jdk"};